<p>{{ isSuccess ? 'Passkey rename successful!' : 'Passkey rename failed.' }}</p>
